import { createSelector } from 'reselect';

// Config
import { getSessionHandoverFailedSelector, getSessionHandoverCompleteSelector } from '@redux/reducers/bff/bffSelector';
import {
  getAuth0AccessTokenSelector,
  getRequestAccessTokenSelector,
} from '@redux/reducers/mobileApps/mobileAppsSelector';
import { getLoginPageCompleteSelector } from '@redux/reducers/login/loginSelector';

const sessionManagerSelector = createSelector(
  [
    getSessionHandoverFailedSelector,
    getSessionHandoverCompleteSelector,
    getLoginPageCompleteSelector,
    getAuth0AccessTokenSelector,
    getRequestAccessTokenSelector,
  ],
  (sessionHandoverComplete, sessionHandoverFailed, getLoginPageComplete, auth0AccessToken, requestAccessToken) => ({
    sessionHandoverComplete,
    sessionHandoverFailed,
    getLoginPageComplete,
    auth0AccessToken,
    requestAccessToken,
  }),
);

export default sessionManagerSelector;
